import {isLocal} from '../../config/env';

const isRollbarFlagEnabled = () => {
  return !isLocal();
};

export {isRollbarFlagEnabled};